import React from 'react';
import Popover from '@mui/material/Popover';
import styled from 'styled-components';

export const AnchorPopup = ({ children, ...rest }) => {
  return (
    <Popover
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      {...rest}
    >
      <PopupBody>{children}</PopupBody>
    </Popover>
  );
};

export const PopupBody = styled.div`
  width: 380;
  height: auto;
  min-height: 100px;
  padding: 10px;
`;
